import styled, {keyframes} from 'styled-components';
import * as DialogPrimitive from '@radix-ui/react-dialog';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const Dialog = styled(DialogPrimitive.Root)``;

const DialogTrigger = styled(DialogPrimitive.Trigger)``;

const DialogPortal = styled(DialogPrimitive.Portal)``;

const DialogClose = styled(DialogPrimitive.Close)`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

const DialogOverlay = styled(DialogPrimitive.Overlay)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  cursor: pointer;

  &[data-state='open'] {
    animation: ${fadeIn} 200ms ease-out;
  }

  &[data-state='closed'] {
    animation: ${fadeOut} 200ms ease-in;
  }
`;

const DialogContent = styled(DialogPrimitive.Content)`
  position: fixed;
  top: 50%;
  left: 50%;
  padding: 20px;
  z-index: 50;
  transform: translate(-50%, -50%);

  &[data-state='open'] {
    animation: ${fadeIn} 200ms ease-out;
  }

  &[data-state='closed'] {
    animation: ${fadeOut} 200ms ease-in;
  }
`;

const DialogHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

const DialogFooter = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
`;

const DialogTitle = styled(DialogPrimitive.Title)`
  font-size: 24px;
  font-weight: bold;
`;

const DialogDescription = styled(DialogPrimitive.Description)`
  font-size: 16px;
  color: #555;
  margin-bottom: 10px;
`;

const QRCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

const QRCode = styled.img`
  width: 200px;
  height: 200px;
`;

const Button = styled.button`
  background-color: #007aff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 16px;
  cursor: pointer;
  margin-left: 10px;

  &:hover {
    background-color: #0062cc;
  }
`;

export {
  Dialog,
  DialogTrigger,
  DialogPortal,
  DialogClose,
  DialogOverlay,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
  QRCodeContainer,
  QRCode,
  Button,
};
